var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m166.001-123.848-42.153-42.153 134.001-134H140.001V-360H360v219.999h-59.999v-117.848l-134 134.001Zm627.998 0-134-134.001v117.848H600V-360h219.999v59.999H702.151l134.001 134-42.153 42.153ZM140.001-600v-59.999h117.848l-134.001-134 42.153-42.153 134 134.001v-117.848H360V-600H140.001ZM600-600v-219.999h59.999v117.848l134-134.001 42.153 42.153-134.001 134h117.848V-600H600Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom_in.906fd012b2baf86e01dd397bb8f15202.svg";
export { ForwardRef as ReactComponent };